import { sanitizeEmail, sanitizeText } from './sanitize';

export function parseQuickSaleAmount(value) {
  let normalized = String(value || '').trim().replace(/\s/g, '').replace(/[^\d.,]/g, '');
  const comma = normalized.lastIndexOf(',');
  const dot = normalized.lastIndexOf('.');

  if (comma > dot) {
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (dot > comma && comma >= 0) {
    normalized = normalized.replace(/,/g, '');
  } else if (comma >= 0) {
    normalized = normalized.replace(',', '.');
  }

  const amount = Number(normalized);
  return Number.isFinite(amount) ? amount : 0;
}

export function buildQuickSalePayload({
  numero,
  fecha,
  cliente,
  concepto,
  monto,
  estadoPago = 'pagada',
  formaPago = 'Transferencia',
  vencimiento = '',
  clienteData = null,
  categoria = 'Otro',
}) {
  const amount = parseQuickSaleAmount(monto);
  const customerName = String(cliente || '').trim() || 'Consumidor final';
  const clientEmail = sanitizeEmail(clienteData?.email || '');
  const clientPhone = sanitizeText(clienteData?.telefono || clienteData?.phone || '');
  const clientCountry = sanitizeText(clienteData?.pais || clienteData?.country || 'Argentina');
  const clientId = clienteData?._id || clienteData?.id || undefined;

  return {
    numero: String(numero || '').trim(),
    fecha,
    cliente: sanitizeText(customerName),
    razonSocial: sanitizeText(customerName),
    conceptos: [{
      detalle: sanitizeText(String(concepto || '').trim()),
      importe: amount,
    }],
    moneda: 'ARS',
    formaPago,
    vencimiento: estadoPago === 'impaga' ? vencimiento : '',
    estadoPago,
    recurrente: false,
    notas: '',
    tipo: 'C',
    alicuotaIva: 0,
    subtotal: amount,
    tax: 0,
    total: amount,
    email: clientEmail,
    pais: clientCountry,
    clientId,
    documentType: 'Venta rápida',
    categoria: sanitizeText(String(categoria || '').trim()) || 'Otro',
    metadata: {
      entryMode: 'quick',
      ...(clientPhone ? { telefono: clientPhone } : {}),
    },
  };
}
